export default (input) => {
  var parts = input.split(":")
  var ns = parts[0]
  var key = parts[1]
  var text = App.Text.get(key, ns)

  var result = {
    text: text,
    class: null,
  }

  switch (key) {
    case "Unpublished":
    case "Draft":
      result.class = "status-box status-box-draft"
      break
    case "Published":
    case "Live":
      result.class = "status-box status-box-live"
      break
    case "ReadyForReview":
      result.class = "status-box status-box-readyforreview"
      break
    case "Approved":
      result.class = "status-box status-box-approved"
      break
    case "NotApproved":
      result.class = "status-box status-box-notapproved"
      break
    case "Undefined":
      result.class = "status-box status-box-undefined"
      break
    case "Archived":
      result.class = "status-box status-box-archived"
      break
    case "Active":
      result.class = "status-box status-box-active"
      break
    case "ReadyForAssessing":
      result.class = "status-box status-box-readyforassessing"
      break
    case "Pending":
      result.class = "status-box status-box-pending"
      break
    case "AssessingInProgress":
      result.class = "status-box status-box-inprogress"
      break
    case "Ongoing":
      result.class = "status-box status-box-ongoing"
      break
    case "NotStarted":
      result.class = "status-box status-box-notstarted"
      break
    case "Assessing":
      result.class = "status-box status-box-assessing"
      break
    case "NotSatisfactory":
      result.class = "status-box status-box-notsatisfactory"
      break
    case "NotSubmitted":
      result.class = "status-box status-box-notsubmitted"
      break
    case "Passed":
      result.class = "status-box status-box-passed"
      break
    case "WaitingCoassessors":
      result.class = "status-box status-box-waitingforcoassessors"
      break
    case "ModerationNeeded":
      result.class = "status-box status-box-moderationneeded"
      break
    case "ModerationInProgress":
      result.class = "status-box status-box-moderationinprogress"
      break
    case "Satisfactory":
      result.class = "status-box status-box-satisfactory"
      break
    case "ModerationComplete":
      result.class = "status-box status-box-moderationcomplete"
      break
    case "ModerationNotNeeded":
      result.class = "status-box status-box-moderationnotneeded"
      break
    case "WaitingForModerator":
      result.class = "status-box status-box-waitingformoderator"
      break
    case "Assessed":
      result.class = "status-box status-box-assessed"
      break
    case "NotHandedIn":
      result.class = "status-box status-box-white"
      break
    case "HandedIn":
      result.class = "status-box status-box-blue"
      break
    case "ModerationHandedIn":
      result.class = "status-box status-box-blue"
      break
    case "ScoringInProgress":
      result.class = "status-box status-box-orange"
      break
    case "Voided":
      result.class = "status-box status-box-red"
      break
    case "WaitingForCoAssessor":
      result.class = "status-box status-box-orange"
      break
    case "ModerationScoringInProgress":
      result.class = "status-box status-box-orange"
      break
    case "ScoringComplete":
      result.class = "status-box status-box-green"
      break
    case "ModerationScoringComplete":
      result.class = "status-box status-box-green"
      break
    case "ModerationAssessingComplete":
      result.class = "status-box status-box-green"
      break
    case "AssessingComplete":
      result.class = "status-box status-box-green"
      break
    default:
      result.class = "status-box status-box-undefined"
      break
  }

  return result
}
